import { useMemo } from 'react';

import { formatTimeInput, makeTimeList } from '../helpers/time-picker.helper';
import { TimePickerProps } from '../time-picker.types';

export function useTimePicker(props: TimePickerProps) {
  const {
    offset,
    placement,
    useAutoPlacement,
    startHour,
    endHour,
    increment,
    timeInputType,
    onInputChange,
    onListChange,
    ...inputProps
  } = props;
  const rootProps = { offset, placement, useAutoPlacement };

  const timeList = useMemo(
    () => makeTimeList({ timeInputType, startHour, endHour, increment }),
    [endHour, increment, startHour, timeInputType]
  );

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const formatted = formatTimeInput(e.target.value);
    if (formatted) {
      onInputChange?.({
        ...e,
        target: { ...e.target, value: formatted },
      }); // Re-dispatch change event so parent can receive it
    }
    props.onBlur?.(e); // Call parent's onBlur if provided
  };

  return { rootProps, timeList, inputProps, handleBlur };
}
